// Pure assessment-schema checks. No network, credentials, or browser dependencies.
// A new assessment remains unpublished until its report and Gateway flow are approved.
export function validateAssessmentDefinition(definition) {
  const issues=[];
  if(!definition || typeof definition!=='object' || Array.isArray(definition)) return ['Assessment definition must be an object'];
  if(!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(definition.id||'')) issues.push('A stable lowercase assessment ID is required');
  if(!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(definition.shortCode||'')) issues.push('A stable lowercase short code is required');
  if(typeof definition.title!=='string' || !definition.title.trim()) issues.push('Assessment title is required');
  if(!Array.isArray(definition.questions) || !definition.questions.length) return [...issues,'At least one question is required'];
  const seen=new Set();
  for(const q of definition.questions) {
    if(!q || typeof q.id!=='string' || !/^[a-z][a-z0-9_]*$/.test(q.id)) {issues.push('Every question needs a valid ID');continue;}
    if(seen.has(q.id)) issues.push('Duplicate question ID: '+q.id);
    seen.add(q.id);
    if(typeof q.prompt!=='string' || !q.prompt.trim()) issues.push('Question prompt missing: '+q.id);
    if(q.type==='choice') {
      if(!Array.isArray(q.options) || q.options.length<2 || new Set(q.options).size!==q.options.length || q.options.some(x=>typeof x!=='string'||!x.trim())) issues.push('Invalid options: '+q.id);
    } else if(q.type==='number') {
      if(!Number.isFinite(q.min)||!Number.isFinite(q.max)||q.min>q.max) issues.push('Invalid numerical bounds: '+q.id);
    } else issues.push('Unsupported question type: '+q.id);
  }
  return issues;
}
export function validateAssessmentAnswers(answers,questions) {
  if(!answers || typeof answers!=='object' || Array.isArray(answers) || !Array.isArray(questions)) return false;
  return questions.every(q=>{
    const value=answers[q.id];
    if(q.type==='choice') return Array.isArray(q.options)&&q.options.includes(value);
    if(q.type==='number') return value!=='' && value!==undefined && value!==null &&
      (typeof value==='number'||typeof value==='string'&&value.trim()!=='') &&
      Number.isFinite(Number(value)) && Number(value)>=q.min && Number(value)<=q.max;
    return false;
  });
}